<template>
  <el-dialog
    :title="oldRateCard.name"
    visible
    top="5vh"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('update:isShow', false)"
  >
    <h1>Duplicate Rate Card</h1>
    <el-form
      ref="duplicateForm"
      v-loading="isSaving"
      :rules="rules"
      :model="newRateCard"
      size="small"
    >
      <el-form-item
        label="Name"
        prop="name"
      >
        <el-input
          v-model="newRateCard.name"
          placeholder="Rate Card Name"
          clearable
        />
      </el-form-item>

      <el-form-item
        label="Start Date"
        prop="date_start"
      >
        <el-date-picker
          v-model="newRateCard.date_start"
          type="date"
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          placeholder="Pick a Start Date"
          :picker-options="datePickerOption"
          class="w-100"
          clearable
        />
      </el-form-item>

      <el-form-item
        label="End Date"
        prop="date_end"
      >
        <el-date-picker
          v-model="newRateCard.date_end"
          type="date"
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          placeholder="Pick a End Date"
          :picker-options="datePickerOption"
          class="w-100"
          clearable
        />
      </el-form-item>

      <el-form-item
        label="Group"
        prop="group"
      >
        <el-select
          v-model="newRateCard.group"
          placeholder="Unchanged"
          class="w-100"
        >
          <el-option
            label="Unchanged"
            :value="null"
          />
          <el-option
            label="New Group"
            :value="true"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="duplicate"
      >
        Duplicate
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oldRateCard: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      newRateCard: {},
      isFullscreen: false,
      isSaving: false,
      datePickerOption: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'A week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      rules: {
        name: [
          { required: true, message: 'Name of the Rate Card is required', trigger: ['blur', 'change'] },
          { min: 5, max: 45, message: 'Length should be 5 to 45', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created () {
    this.$set(this.newRateCard, 'name', this.oldRateCard.name)
    this.$set(this.newRateCard, 'date_start', new Date())
  },
  methods: {
    duplicate () {
      this.$refs.duplicateForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          const job = new this.$sdk.job()
          job.name = 'bulk.combined'
          job.parameters = {
            model_key: 'ratecard',
            duplicate: [
              this.oldRateCard.id
            ],
            update: {
              fields: {
                name: this.newRateCard.name || '',
                profile: this.$user.instance.id,
                date_start: this.newRateCard.date_start ? this.$moment(this.newRateCard.date_start).format('YYYY-MM-DD 00:00:00') : null,
                date_end: this.newRateCard.date_end ? this.$moment(this.newRateCard.date_end).format('YYYY-MM-DD 00:00:00') : null,
                new_group: this.newRateCard.group ? this.newRateCard.group : null
              }
            }
          }
          job.create()
            .then(() => this.$message({ message: 'Job has been added to the queue', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('update:isShow', false)
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
